var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 981.429 981.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M980.846 35.422l.197-1.17.186-1.21.111-1.29.077-1.114.007-1.307-.015-1.114-.095-1.25-.112-1.171-.184-1.158-.222-1.238-.264-1.08-.334-1.264-.356-1.064-.429-1.215-.488-1.135-.479-1.072-.695-1.303-.392-.734-.067-.103-.904-1.398-.435-.661-.994-1.285-.51-.652-.93-1.014-.726-.786-.739-.683-1.061-.973-.622-.487-1.314-1.017-.654-.43L967 4.136l-.104-.068-.744-.397-1.29-.688-1.093-.489-1.111-.478-1.25-.441-1.025-.342-1.315-.348-1.025-.25-1.303-.234-1.09-.173-1.246-.12-1.173-.089-1.2-.016c-.407-.002-.812-.009-1.22.007l-1.209.084-1.197.103-1.306.201-1.077.182-1.5.362-.756.182-.264.076-.017.005L21.406 265.443a29.545 29.545 0 0 0-7.032 53.753l405.305 242.546L662.22 967.05a29.544 29.544 0 0 0 53.752-7.031L980.304 37.664l.202-.834.34-1.408zM850.259 89.387L436.62 503.019 103.176 303.477zM677.94 878.248L478.402 544.802 892.04 131.169z",
    fill: "#2f2f52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d23fa53f3f6c663eab5e664b89a7a5e7.svg";
export { ForwardRef as ReactComponent };